/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from '../forms.module.scss';
import Button from '../../../components/button/button';

class FormSubmitted extends Component {
  render() {
    const { name, message, logo, successMessage, isForm, handleEntry, handleGoForms, isDraft, fromFormDraft,
      ispublicForm, form_submission_success_msg, trackingId, formParent, fontStyle, submitAnotherEntry
    } = this.props;
    return (
      <div className={styles.submittedContainer}>
        <img src={logo} alt="" />
        {successMessage?.length > 0 && (
          <div style={{ padding: '25px', fontSize: fontStyle ? '25px' : '16px', fontWeight: fontStyle ? 'bold' : 'normal' }}
          dangerouslySetInnerHTML={{ __html: successMessage }} />
        )}
        {(successMessage?.length === 0 || !successMessage) && !ispublicForm && (
          <>
            <span className={styles.inspectionName}>{ name }</span>
            <span className={styles.submitted_msg} style={{ margin: submitAnotherEntry ? '20px': '13rem 8rem' }}>
              {message}
            </span>
          </>
        )}
         {submitAnotherEntry
              &&<Button
              action="secondary"
              onClick={() => window.location.reload()}
              translationID="inspections.new"
              defaultText="Submit Another Entry"
            />}
        <div className={styles.goForms}>
          {(isForm || fromFormDraft)&& (
          <>
            {!isDraft
            && <Button
                action="secondary"
                onClick={handleEntry}
                translationID={'forms.complete_form.another.entry'}
                defaultText={'Submit Another Entry'}
              />}
            <Button
              action="secondary"
              onClick={handleGoForms}
              translationID={'forms.complete_form.go_to_forms'}
              defaultText={'Go to Forms'}
            />
          </>
          )}
        </div>
        {ispublicForm && (
          <>
            <span className={styles.submitted_msg}>
              {form_submission_success_msg}
            </span>
            {formParent?.form?.settings?.enable_check_public_status_for_workflow_form
            && (
              <span className={styles.trackingMessage}>
                Please keep the reference number <b>{trackingId}</b> for future inquiries or tracking.
              </span>
            )}
          </>
        )}
      </div>
    );
  }
}

FormSubmitted.propTypes = {
  name: PropTypes.string.isRequired
};

export default FormSubmitted;
